import React, { useEffect } from 'react';
import { sendTrackingInfo } from '@panel/commons';
import { useTranslation } from 'react-i18next';
import { ModalInformation } from '@panel/commons/lib/Modals/ModalInformation';

function NormalFlowDraftToOnDone(props) {
  const { onClickAction, selectedPlanName } = props;
  const { t } = useTranslation();

  useEffect(() => {
    sendTrackingInfo('Mis avisos', `Publicar Aviso ${selectedPlanName}-Exito`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ModalInformation
      onClickAction={onClickAction}
      onClickOutside={onClickAction}
      title={t('panel.modal.NormalFlowDraftToOnDone.title')}
      message={t('panel.modal.NormalFlowDraftToOnDone.text')}
      ctaOk={t('panel.modal.cta.ok')}
    />
  );
}

export { NormalFlowDraftToOnDone };
